import axios from 'axios';
import { store } from '../store';
import { logout } from '../store/slices/authSlice';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000/api';

// Crear instancia de axios con configuración base
const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para añadir token de autenticación a las peticiones
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token');
    if (token && config.headers) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para manejar errores de respuesta
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      // Si el error es 401 (No autorizado), limpiar el token y redirigir al login
      // Un 401 significa que la sesión ha expirado o el token es inválido
      if (error.response.status === 401) {
        localStorage.removeItem('auth_token');
        store.dispatch(logout());
        const mensaje = 'Tu sesión ha expirado. Por favor, inicia sesión nuevamente.';
        sessionStorage.setItem('auth_redirect_message', mensaje);
        window.location.href = '/login';
      }
      // Un 403 (Prohibido) significa que el usuario no tiene permisos para esa acción específica
      // pero su sesión sigue siendo válida, así que NO redirigimos al login
      // El componente que hace la petición debe manejar el error apropiadamente
    }
    return Promise.reject(error);
  }
);

export { apiClient }; 